export function createElement(tag: string, className?: string, textContent?: string): HTMLElement {
  const element = document.createElement(tag);
  if (className) {
    element.className = className;
  }
  if (textContent) {
    element.textContent = textContent;
  }
  return element;
}

export function createButton(text: string, className?: string, onClick?: () => void): HTMLButtonElement {
  const button = createElement('button', className, text) as HTMLButtonElement;
  button.type = 'button';
  if (onClick) {
    button.addEventListener('click', onClick);
  }
  return button;
}

export function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

export function clearElement(element: HTMLElement | HTMLSelectElement): void {
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
}

export function isMobileDevice(): boolean {
  // Check for touch capability
  const hasTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  // Check user agent for mobile devices
  const userAgent = navigator.userAgent.toLowerCase();
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  const isMobileUserAgent = mobileRegex.test(userAgent);
  
  // Consider it mobile if it has touch capability or matches mobile user agent
  return hasTouchScreen || isMobileUserAgent;
}
